import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectAccidentalDeathAndDismembermentStep = (state) => state.get('accidentalDeathAndDismembermentStep');

const makeSelectAccidentalDeathAndDismembermentStep = () => createSelector(
  selectAccidentalDeathAndDismembermentStep,
  (stepAccidentalDeathAndDismembermentState) => ({
    areYouClaimingForAccidentalDeathAndDismemberment: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'areYouClaimingForAccidentalDeathAndDismemberment']),
      ''
    ),

    groupName: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'groupName']),
      ''
    ),

    relationshipToInsured: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'relationshipToInsured']),
      ''
    ),

    address: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'address']),
      ''
    ),

    cityOrTown: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'cityOrTown']),
      ''
    ),

    state: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'state']),
      ''
    ),

    postalCode: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'postalCode']),
      ''
    ),

    phoneNumber: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'phoneNumber']),
      ''
    ),

    country: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'country']),
      ''
    ),
    dateOfAccident: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'dateOfAccident']),
      ''
    ),
    dateOfDismembermentOrLossOfUse: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'dateOfDismembermentOrLossOfUse']),
      ''
    ),
    dateOfDeath: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'dateOfDeath']),
      ''
    ),
    hospitalConfined: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'hospitalConfined']),
      ''
    ),
    dates: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'dates']),
      ''
    ),
    hospital: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'hospital']),
      ''
    ),
    addressForHospital: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'addressForHospital']),
      ''
    ),
    cityOrTownForHospital: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'cityOrTownForHospital']),
      ''
    ),
    countryForHospital: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'countryForHospital']),
      ''
    ),
    postalCodeForHospital: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'postalCodeForHospital']),
      ''
    ),
    describeHowTheAccidentOccurred: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'describeHowTheAccidentOccurred']),
      ''
    ),

    // For Common
    areYouClaimingForCommonCarrierAccidentalDeathAndDismemberment: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'areYouClaimingForCommonCarrierAccidentalDeathAndDismemberment']),
      ''
    ),

    groupNameForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'groupNameForCommon']),
      ''
    ),

    relationshipToInsuredForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'relationshipToInsuredForCommon']),
      ''
    ),

    addressForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'addressForCommon']),
      ''
    ),

    cityOrTownForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'cityOrTownForCommon']),
      ''
    ),

    stateForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'stateForCommon']),
      ''
    ),

    postalCodeForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'postalCodeForCommon']),
      ''
    ),

    phoneNumberForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'phoneNumberForCommon']),
      ''
    ),

    countryForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'countryForCommon']),
      ''
    ),
    dateOfAccidentForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'dateOfAccidentForCommon']),
      ''
    ),
    dateOfDismembermentOrLossOfUseForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'dateOfDismembermentOrLossOfUseForCommon']),
      ''
    ),
    dateOfDeathForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'dateOfDeathForCommon']),
      ''
    ),
    hospitalConfinedForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'hospitalConfinedForCommon']),
      ''
    ),
    datesForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'datesForCommon']),
      ''
    ),
    hospitalForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'hospitalForCommon']),
      ''
    ),
    addressForHospitalForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'addressForHospitalForCommon']),
      ''
    ),
    cityOrTownForHospitalForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'cityOrTownForHospitalForCommon']),
      ''
    ),
    countryForHospitalForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'countryForHospitalForCommon']),
      ''
    ),
    postalCodeForHospitalForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'postalCodeForHospitalForCommon']),
      ''
    ),
    describeHowTheAccidentOccurredForCommon: mapWithDefault(
      stepAccidentalDeathAndDismembermentState,
      () => stepAccidentalDeathAndDismembermentState.getIn(['form', 'describeHowTheAccidentOccurredForCommon']),
      ''
    ),
  })
);

const makeSelectAccidentalDeathAndDismembermentStepErrors = () =>
  createSelector(selectAccidentalDeathAndDismembermentStep, (state) => state.get('errors'));

export {
  makeSelectAccidentalDeathAndDismembermentStep,
  makeSelectAccidentalDeathAndDismembermentStepErrors,
};



// WEBPACK FOOTER //
// ./app/containers/FastCover/Trawick.NationWide.AccidentalDeathAndDismembermentStep/selectors.js